<script setup>
import { ref } from 'vue';
import EstadisticasTerritorio from '@/components/EstadisticasTerritorio.vue';
import EstadisticasTerritorioAmigable from '@/components/EstadisticasTerritorioAmigable.vue';

const modoImprimible = ref(false);
</script>
<template>
  <div>
    <div class="flex justify-content-end p-3 pb-0 noprint">
      <Button
        :label="modoImprimible ? 'Volver a vista amigable' : 'Ver formato imprimible S-13'"
        :icon="modoImprimible ? 'pi pi-table' : 'pi pi-print'"
        severity="secondary"
        @click="modoImprimible = !modoImprimible"
      />
    </div>
    <EstadisticasTerritorioAmigable v-if="!modoImprimible" />
    <EstadisticasTerritorio v-else />
  </div>
</template>
